import { render } from "./EventDocument.vue?vue&type=template&id=0be14fa4"
import script from "./EventDocument.vue?vue&type=script&lang=ts"
export * from "./EventDocument.vue?vue&type=script&lang=ts"
script.render = render

export default script